import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  type IMapGetBboxResponse200,
  type IMapGetBboxResponse400,
  type TMapGetBboxRequest,
  type TMapGetBboxResponse_1,
  createMapGetBboxModel,
  fetchMapGetBbox,
} from '@/repositories/generated/shared/search-offers-index/v2/map/get-bbox';

type FetchServiceParams = {
  applicationContext: IQueryStateAppContext;
  parameters: TMapGetBboxRequest;
};

export function fetchMapGetBboxService(params: FetchServiceParams): Promise<TMapGetBboxResponse_1> {
  const {
    applicationContext: { httpApi, logger },
    parameters,
  } = params;

  const fetchAssertsService = new FetchAssertsService(
    createMapGetBboxModel(parameters),
    '@/shared/store/serverSide/search-offers-index/v2/get-bbox/internal/fetchService.ts',
    logger,
  );

  return fetchMapGetBbox<IMapGetBboxResponse200, IMapGetBboxResponse400>({
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
